import { render, staticRenderFns } from "./ProductionDetail.vue?vue&type=template&id=46f2994a&scoped=true&"
import script from "./ProductionDetail.vue?vue&type=script&lang=js&"
export * from "./ProductionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductionDetail.vue?vue&type=style&index=0&id=46f2994a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f2994a",
  null
  
)

export default component.exports